import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import users from './store/modules/users';
import collections from './store/modules/collections'; // eslint-disable-line import/no-cycle
import notes from './store/modules/notes';
import cards from './store/modules/cards';
import files from './store/modules/files';
import notifications from './store/modules/notifications';
import appState from './store/modules/appState';
import search from './store/modules/search';
import sync from './store/modules/sync';

// Set axios defaults
// axios.defaults.baseURL = 'http://localhost:8088/';
axios.defaults.baseURL = 'https://www.byblio.app/api/';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    users,
    collections,
    notes,
    cards,
    files,
    notifications,
    appState,
    search,
    sync,
  },
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  getters: {
    //
  },
});

export default store;

const initialStateCopy = JSON.parse(JSON.stringify(store.state));

export function resetState() {
  store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)));
}
